var map = {
	"app/terminal/terminal.module.ngfactory": [
		"./src/app/terminal/terminal.module.ngfactory.js",
		"terminal.module"
	],
	"app/user/user.module.ngfactory": [
		"./src/app/user/user.module.ngfactory.js",
		"user.module"
	],
	"app/vehicle/vehicle.module.ngfactory": [
		"./src/app/vehicle/vehicle.module.ngfactory.js",
		"vehicle.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main